import { createSlice } from '@reduxjs/toolkit';
import { revertAll } from './userSlice';

const initialState = {
  evalList: null,
  screenSize: null,
}

export const listsSlice = createSlice({
  name: 'lists',
  initialState,
  extraReducers: (builder) => builder.addCase(revertAll, () => initialState),
  reducers: {
    setEvalList: (state, action) => {
      state.evalList = action.payload
    },
    setScreenSize: (state, action) => {
      state.screenSize = action.payload
    },
  },
})

// Action creators are generated for each case reducer function
export const { 
  setEvalList, 
  setScreenSize
} = listsSlice.actions

export default listsSlice.reducer